import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-component',
  templateUrl: './confirm.component.html',
  styles: [
  ]
})
export class ConfirmComponent implements OnInit {

  title: string = null;
  prompt: string = 'Are you sure?';
  cancelBtnClass: string = 'btn-outline-black';
  okBtnClass: string = 'btn-secondary';
  cancelBtnText: string = 'Cancel';
  okBtnText: string = 'OK';
  cancelBtnIcon: string = null;
  okBtnIcon: string = null;

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmModal(): void {
    this.modal.close();
  }

  dismissModal(): void {
    this.modal.dismiss();
  }
}
